// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V6bxV{position:relative;width:100%;min-width:0}.iLuCD{display:flex;flex-direction:row;align-items:center;gap:8px;padding:12px;background-color:#fff;border-radius:8px}.iLuCD.qjXY8{cursor:pointer}.Ffpyc{display:flex;flex-direction:row;align-items:center;gap:8px;flex:1 1 auto;min-width:0}.Estuo{margin-left:auto}.Dxopk{position:relative;width:100%;min-width:0}.f5uFH{width:100%;min-width:0;overflow-x:auto;overflow-y:visible;padding:12px 0;scrollbar-width:none;-ms-overflow-style:none}.f5uFH::-webkit-scrollbar{display:none}.NGCwu{display:flex;flex-direction:row;flex-wrap:nowrap;width:100%}.X40yU{flex:0 0 auto}.eLR_E{flex:1 1 var(--carousel-item-min-width, 240px);min-width:var(--carousel-item-min-width, 240px)}.mpqCM{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;grid-template-columns:unset !important;grid-template-rows:unset !important;grid-auto-flow:unset !important;grid-auto-columns:unset !important;width:100%;justify-content:start;overflow:visible !important}.jB6oO{flex:0 0 auto !important;touch-action:pan-x !important}.ANPqz{flex:1 1 var(--carousel-item-min-width, 240px) !important;min-width:var(--carousel-item-min-width, 240px) !important;touch-action:pan-x !important}._doWP{position:absolute;top:12px;bottom:12px;width:88px;pointer-events:none;opacity:0;transition:opacity .2s ease;z-index:1}.o76j0{opacity:1}.n6PZ6{left:0;background:linear-gradient(to right, var(--color-bg-base, #f4f5f8), transparent)}.dd1_c{right:0;background:linear-gradient(to left, var(--color-bg-base, #f4f5f8), transparent)}.pW_Cw{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:40px;height:40px;padding:0;margin:0;border-radius:50%;background:#fff;border:1px solid #d4d4e0;color:#bfbfd0;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;pointer-events:none;transition:opacity .2s ease,color .15s ease,border-color .15s ease}.pW_Cw:hover:not(:disabled),.pW_Cw:active:not(:disabled){color:#282863;border-color:#282863}.pW_Cw:focus-visible{outline:2px solid #282863;outline-offset:2px}.oNu9A{opacity:1;pointer-events:auto}.lQpzI{left:20px}.xQUj3{right:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `V6bxV`,
	"header": `iLuCD`,
	"tappable": `qjXY8`,
	"headerContent": `Ffpyc`,
	"chevron": `Estuo`,
	"viewport": `Dxopk`,
	"scroller": `f5uFH`,
	"track": `NGCwu`,
	"item": `X40yU`,
	"itemEqual": `eLR_E`,
	"draggableTrackOverride": `mpqCM`,
	"draggableItem": `jB6oO`,
	"draggableItemEqual": `ANPqz`,
	"fade": `_doWP`,
	"fadeVisible": `o76j0`,
	"fadeLeft": `n6PZ6`,
	"fadeRight": `dd1_c`,
	"arrowButton": `pW_Cw`,
	"arrowButtonVisible": `oNu9A`,
	"arrowButtonLeft": `lQpzI`,
	"arrowButtonRight": `xQUj3`
};
export default ___CSS_LOADER_EXPORT___;
